// 구매용, 입찰용
export enum ProjectType {
  BUY = 'BUY',
  BID = 'BID',
}

export enum ProjectSubType {
  BID_PURCHASE = 'BID_PURCHASE', // 구매입찰용
  BID_BUDGET = 'BID_BUDGET', // 예가용
}

// 카트, 파일
export enum OptionType {
  CART = 'CART',
  FILE = 'FILE',
}

export enum ReqDeliveryAtType {
  AT = 'SPECIFIC_DATE',         //2024-08-01
  AFTER_ORDER = 'AFTER_ORDER',  //발주 이후 OO 일
}

// 구매자 프로젝트 생성(견적요청) form
export type BuyerProjectFormType = {
  readonly [key: string]: string | boolean | number[];
  readonly kind: ProjectType; // 입찰용, 구매용
  readonly sub_kind: ProjectSubType | string; // 입찰용, 구매용
  readonly cart_ids: number[]; // 카트 id 배열
  readonly quotation_file: string; // 요청 파일
  readonly quotation_file_name: string; // 파일 이름
  readonly project_name: string; // 프로젝트 명
  readonly end_customer: string; // 최종수요자
  readonly req_delivery_at_type: ReqDeliveryAtType; //납기 일자 지정 방식
  readonly req_close_at: string; // 견적 마감일자
  readonly is_consultable: boolean; // 요청 납기 일자 협의 가능
  readonly req_delivery_at: string; // 요청 납기일자
  readonly req_delivery_days: string; // 요청 납기일자 - 발주 후 몇일
  readonly is_restricted_country: boolean; // 원산지 제한국가 없음
  readonly restricted_country: string; // 원산지 제한국가
  readonly terms_of_payment: string; // 거래조건
  readonly terms_of_payment_text: string; // 거래조건 text
  readonly is_loading: boolean; // 상차도 여부
  readonly shipping_area: string; // 납품지역
  readonly is_approved_vendor_list_file: boolean; // 승인 업체 리스트 없음
  readonly approved_vendor_list_file_name: string; // 승인 업체 리스트 파일 명
  readonly approved_vendor_list_file: string; // 승인 업체 리스트 File
  readonly approved_vendor_list: string; // 승인 업체 리스트 Text
  readonly additional_request: string; // 추가 요청사항 Text
  readonly additional_request_file: string; // 추가 요청사항 File
  readonly additional_request_file_name: string; // 추가 요청사항 파일명
  readonly is_additional_request_file: boolean; // 추가 요청사항 text 여부
  readonly is_agree: boolean; // 필수 동의 사항
};

export enum StatusType {
  DEFAULT = 'DEFAULT', // 일반 요청 (카트, 파일)
  CMP = 'CMP', // 내용보완
  BY_BID = 'BY_BID', // 입찰용 -> 구매용
}
